<script>
    import model from '../../stores/modelStore';
    import { projectSettings } from '../../config';
    import { registerFormStart } from "../../gtm";

    import PageSection from '../../components/PageSection.svelte';
    import Form from '../../components/Form.svelte';
    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';
    import ClassActionEmailAddress from '../../components/ClassActionEmailAddress.svelte';
    import ClassActionPhoneNumber from '../../components/ClassActionPhoneNumber.svelte';
    import NavigationButtons from '../../components/NavigationButtons.svelte';
    import Checkbox from '../../components/Checkbox.svelte';

    export let pageTitle = null;
    export let lastVisitedPage = null;
    export let disabled = null;
    
	let buttons;

    if (!disabled) {
        $model.LastPageVisited = lastVisitedPage;
        document.title = pageTitle;

        //  Get the user Agent
        $model.UserAgent = navigator.userAgent;
        $model.referrer = document.referrer;
        $model.RegistrationSegmentId = null;
    }

	const handleSubmit = (e) =>{
        buttons.blockNext();

        e.preventDefault();
        grecaptcha.ready(function() {
            grecaptcha.execute(projectSettings.gSiteKey, {action: 'submit'}).then(async function(token) {
                let options = {
		            method: "POST",
		            headers: {
			            "Content-type": "application/json",
		            },
		            body: JSON.stringify({token:token})
	            };

                var url = "/api/verify";
	            let response = await fetch(`${url}`, options);
	            if (response.ok) {
		            let data = await response.json();

                    if (data && data.status === true){
                        registerFormStart();

                        buttons.next();
                        buttons.unblock();
                        return true;
                    }
	            }

                buttons.unblock();
                return false;
            });
        });
    }

</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
        <FormRow class="justify-content-center confirmation-hide">
            <FormColumn>
                <h1 class="text-center">{@html projectSettings.classActionName}</h1>
            </FormColumn>
        </FormRow>

        <FormRow class="justify-content-md-center confirmation-hide">
            <FormColumn>
                <p>
                    To be a part of the Toyota DPF action, you must own or have previously owned a Toyota Hilux, Fortuner, or Prado vehicle* that was manufactured from 1 April 2015 to 31 May 2018, fitted with a 1GD-FTV engine or 2GD-FTV engine. 
                    <br>
                    *Including exchanging, or taking on a lease or on hire-purchase.
                </p>
                
                <p>
                    If you meet this criteria, you may be entitled to compensation, and you are encouraged to register for the Toyota DPF Action.
                </p>
            </FormColumn>
        </FormRow>

	    <div class="confirmation-box-shadow">
            <FormRow>
                <FormColumn>
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="mb-3">
                        Do you agree to provide us with personal information which will be kept confidential under the Shine Lawyers New Zealand 
                        <a href='https://www.shinelawyers.co.nz/privacy-policy/' title='Privacy Policy' target='_blank' rel="noreferrer">Privacy Policy</a>?
                    </label>
                    <Checkbox required="true" {disabled} bind:checked="{$model.privacyPolicyConfirmed}" label="I agree to the privacy policy" id="privacy"></Checkbox>
                </FormColumn>
            </FormRow>
        </div>

        <FormRow class="justify-content-md-center register-btn confirmation-hide">
            <FormColumn class="text-center">
                <NavigationButtons showPrevious={false}
                    bind:buttons
                    nextPageLabel='REGISTER FOR THE ACTION'
                    disableNext={!$model.privacyPolicyConfirmed}></NavigationButtons>
            </FormColumn>
        </FormRow>

        <FormRow class="justify-content-md-center confirmation-hide">
            <FormColumn>
                <p>
                    If you have any questions, or need any assistance filling out the registration form, please contact us on <ClassActionPhoneNumber></ClassActionPhoneNumber> 
                    or at <ClassActionEmailAddress></ClassActionEmailAddress>.
                </p>
            </FormColumn>
        </FormRow>
    </Form>
</PageSection>

<style>
    h1 {
        margin-bottom: 20px;
    }
</style>


